import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { createViewEdit, formatDateTime, getForm } from "../../utils/helpers";
import { URL_RECONCILIATION_STATEMENTS } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_PARTNERS, API_RECONCILIATION_STATEMENTS } from "../../utils/apis";
import { IFormSection } from "../../types/common";
import { StatusTags } from "../../components/common/registerUtils";

const url = URL_RECONCILIATION_STATEMENTS;

export const useReconciliationStatements = () => {
  const tableColumns = () => [
    {
      id: "partner_name",
      header: "Partner Name",
      filter: {},
    },
    {
      id: "partner_code",
      header: "Partner Code",
      filter: {},
    },
    {
      id: "account_number",
      header: "Account Number",
      filter: {},
    },
    {
      id: "start_date",
      header: "Start Date",
      filter: { type: "date" },
    },
    {
      id: "end_date",
      header: "End Date",
      filter: { type: "date" },
    },
    {
      id: "record_date",
      header: "Record Date",
      filter: {},
    },
    {
      id: "status",
      header: "Status",
      filter: {},
    },
    {
      id: "total_transactions",
      header: "Total Transactions",
      filter: {},
    },
    {
      id: "uploaded_by",
      header: "Uploaded By",
      filter: {},
    },
    // {
    //   id: "statement_file",
    //   header: "Statement File",
    // },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        status: <StatusTags status={item?.status} />,
        start_date: formatDateTime(item?.start_date),
        end_date: formatDateTime(item?.end_date),
        record_date: formatDateTime(item?.record_date),
        actions: <FormActions actions={[...createViewEdit(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Reconciliation Statements Details",
          fields: {
            partner_name: item?.partner_name,
            partner_code: item?.partner_code,
            account_number: item?.account_number,
            start_date: item?.start_date,
            end_date: item?.end_date,
            record_date: item?.record_date,
            status: item?.status,
            total_transactions: item?.total_transactions,
            result: item?.result,
            uploaded_by: item?.uploaded_by,
            statement_file: item?.statement_file,
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return {
    tableColumns,
    tableData,
    viewData,
    formRoute,
  };
};

export const useReconciliationStatementsForm = () => {
  const {
    loadData: getPartners,
    data: partners,
    loading: partnersLoading,
    error: partnersError,
  } = useGet();

  useEffect(() => {
    getPartners({ api: API_PARTNERS });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Item Partner Details",
      fields: [
        {
          field_name: "partner",
          label: "Partner Name",
          type: "select",
          props: {
            required: true,
          },
          options_data: partners?.results?.map((item: any) => ({
            id: item.id,
            name: item.partner_name,
            extraFields: {
              partner_code: item.partner_code,
            },
          })),
        },
        {
          field_name: "partner_code",
          label: "Partner Code",
          type: "text",
          props: {
            required: true,
            disabled: true,
          },
        },
        {
          field_name: "account_number",
          label: "Account Number",
          type: "number",
          props: {
            required: true,
          },
        },
        {
          field_name: "start_date",
          label: "Start Date",
          type: "date",
          props: {
            required: true,
            format: "YYYY-MM-DD",
          },
        },
        {
          field_name: "end_date",
          label: "End Date",
          type: "date",
          props: {
            required: true,
            format: "YYYY-MM-DD",
          },
        },
        {
          field_name: "statement_file",
          label: "Statement File",
          type: "file",
          props: {
            required: true,
            placeholder: "Upload Statement File as a CSV",
          },
        },
      ],
    },
  ];

  return {
    sections,
    partnersLoading,
    partnersError,
  };
};

export const submitReconciliationStatements = (payload: any, id: string) => {
  if (id) {
    return {
      id,
      api: `${API_RECONCILIATION_STATEMENTS}`,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: `${API_RECONCILIATION_STATEMENTS}`,
    params: {
      ...payload,
    },
  };
};
